import React from 'react';

import { TypeCard } from '../../../../components/TypeCard';

import { SpecialistList as Specialist } from '../../../../models/Specialist';

const DoctorDefaultIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg';
import { capitalize } from '../../../../utils/formatters';

type SpecialistsType = {
  specialistList: Specialist[];
  specialty: string | undefined;
  selectedSpecialist: Specialist | null;
  handleSelectSpecialist: (specialist: Specialist) => void;
};

export const Specialists: React.FC<SpecialistsType> = ({
  specialistList,
  specialty,
  selectedSpecialist,
  handleSelectSpecialist
}) => {
  return (
    <>
      {specialistList.map(specialist => (
        <TypeCard
          key={specialist.id}
          title={capitalize(specialist.name)}
          description={specialty}
          iconSrc={specialist.profile_picture ? specialist.profile_picture : DoctorDefaultIcon}
          onClick={() => handleSelectSpecialist(specialist)}
          checked={selectedSpecialist ? selectedSpecialist.id === specialist.id : false}
        />
      ))}
    </>
  );
};
